Hi<template>
    <div>
        <app-form
            v-bind:parentObject="{
                data: this.formData,
                pageTitle: this.pageTitle,
                errMsg: this.errMsg,
            }"
            v-on:input="formData = $event"
            v-on:save="saveHandler"
            v-on:error="errorHandler"
        />

        <div v-if="isErr">
            <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>

import RoleAssignmentForm from "../../../components/settings/roleassignment/Form.vue";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": RoleAssignmentForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            pageTitle: this.$t('roleassignment.createnewroleassignment'),
            pageTitleValue: "",

            formData: {
                roleid: null,
                staffid: null,
                ownerstaffid: null,
                startdate: null,
                enddate: null,
                remarks: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                workflowrole: null,
                staffno: null,
                staffcompany: null,
                ownerstaffno: null,
                ownerstaffcompany: null,
            },
            errMsg: "",
            isErr: false
        };
    },

    methods: {
        
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                return false;
            }

            this.$store.dispatch('post', {url: "/roleassignment/create", payload: this.formData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    this.$router.push({ name: "roleassignmentlist" });
                }
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },
    },
};

</script>